export const FETCH_ACTORS_LIST = 'fetchActorsList'
